import { ELIG_TOKENS } from '@features/eligibility-checks/theme/readinessTokens';
import { Box, Stack, Typography } from '@mui/material';

export type ClaimsReviewQueueRowClaim = {
  id: string;
  patient: string;
  dos: string;
  payer: string;
  amount: string;
  primaryBillingCode: string;
  stage: string;
};

type ClaimsReviewQueueRowProps = {
  claim: ClaimsReviewQueueRowClaim;
  active?: boolean;
  onClick?: () => void;
};

export function ClaimsReviewQueueRow({
  claim,
  active = false,
  onClick,
}: ClaimsReviewQueueRowProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        p: 1,
        borderRadius: 1,
        border: `1px solid ${active ? ELIG_TOKENS.midnight : ELIG_TOKENS.line}`,
        bgcolor: active ? '#FBFCFE' : '#fff',
        boxShadow: active ? 'inset 3px 0 0 rgba(13, 31, 45, 0.95)' : 'none',
        transition: 'background-color 120ms ease, border-color 120ms ease',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': {
          bgcolor: '#FBFCFE',
          borderColor: ELIG_TOKENS.lineStrong,
        },
      }}
    >
      <Stack spacing={0.5}>
        <Typography
          sx={{ fontSize: 13.5, fontWeight: 860, color: ELIG_TOKENS.ink, lineHeight: 1.25 }}
          noWrap
        >
          {claim.patient} · {claim.dos}
        </Typography>
        <Typography sx={{ fontSize: 11.5, color: ELIG_TOKENS.inkSoft, lineHeight: 1.35 }} noWrap>
          {claim.primaryBillingCode} · {claim.payer}
        </Typography>
        <Typography
          sx={{ mt: 0.25, fontSize: 12.5, fontWeight: 800, color: ELIG_TOKENS.midnight }}
          noWrap
        >
          {shortStage(claim.stage)} · {claim.amount}
        </Typography>
      </Stack>
    </Box>
  );
}

function shortStage(stage: string) {
  if (stage.startsWith('Rejected')) return 'Rejected';
  if (stage.startsWith('Denied')) return 'Denied';
  if (stage.startsWith('Partially')) return 'Partial';
  return stage;
}
